import { AgentCommon } from '~/agents/common/common/agent'

export const ReceptionistAgentCommon: AgentCommon = {
  key: 'receptionist',
  hasOnboarding: true,
  hasSettings: true,
  guidelines: [],
}
